import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from '../cheats/PopupCheats';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CheatData } from '../cheats/cheats.sequences';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';

const MATCH2_CHAMPIONS_LEAGUE = 'match2 Champions League';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_CHAMPIONS_LEAGUE] = [
    {
      text: 'Reset Leagues',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_resetChampionsLeague();
        closeAllPopups();
      },
    },
    {
      text: 'Increase Score',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_scoreChampionsLeague(1);
      },
    },
    {
      text: 'Increase Score x50',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_scoreChampionsLeague(50);
      },
    },
    {
      text: 'End Current League To Claim',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_endCurrentChampionsLeague();
        closeAllPopups();
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  if (args.key !== MATCH2_CHAMPIONS_LEAGUE) return;
  args.title.updateOpts({
    width: args.item.style.width - 40,
    height: 20,
    y: 8,
    align: 'center',
  });
  args.popup.createVerticalButtons(args.item, args.setting);
};

export const championsLeagueCheats = {
  list,
  ui,
};
